import { ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { FieldWrapper, FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { MatDialogComponent } from 'src/app/components/dialog-box/mat-dialog/mat-dialog.component';
import { LoaderService } from 'src/app/service/loader.service';
import { RestService } from 'src/app/service/rest.service';
import { of } from 'rxjs';
import { SharedService } from 'src/app/service/multiFileUpload.service';
import { FormlyApiService } from 'src/app/service/formly-api.service';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatetimepickerModule } from '@mat-datetimepicker/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { QuillModule } from 'ngx-quill';
import { NgxDropzoneModule } from 'ngx-dropzone';
@Component({
  selector: 'app-multiple-file-upload',
  template: `<div class="container">
    <div class="row mt-3">
      <div class="col-md-12 p-0">
        <mat-label>
          <span class="label"
            ><span><em class="fa {{to.labelIcon||''}}"></em> {{ to.label }}</span>
            <span *ngIf="to.required" class="required-icon">*</span>
          </span>

          <mat-icon
            *ngIf="to['tooltip']"
            matTooltip="{{ to['tooltip'] }}"
            class="icon"
            matTooltipPosition="right"
            >help</mat-icon
          >
        </mat-label>

        <ngx-dropzone
          [disabled]="getDisable()"
          (change)="onFileSelected($event)"
          class="mt-2"
        >
          <ngx-dropzone-label>Drop Files Here</ngx-dropzone-label>
        </ngx-dropzone>
        <div >
          <div *ngIf="isRequired && attachmentID.length == 0 && field.formControl?.touched" class="error-message mt-2 py-1">
            <mat-error>
            {{ field.validation?.messages?.required }}
            </mat-error>
          </div>
          <div *ngIf="filelengthBool" class="error-message mt-2 py-1">
          <mat-error>
            {{ 'Maximum # of files to be uploaded ' }} :{{ fileslength }}
            </mat-error>
          </div>
          <div *ngIf="maxSizeExceeded && submitted" class="error-message mt-2 py-1">
          <mat-error>
            Max file size:{{ to['maxSize'] }}MB
            </mat-error>
          </div>
          <div *ngIf="invalidFileType && submitted" class="error-message mt-2 py-1">
          <mat-error>
            File type allowed : {{to?.['allowedFileTypes']?.join(', ')}}
            </mat-error>
          </div>
          <div *ngIf="fileExits && submitted" class="error-message mt-2 py-1"><mat-error>File Already Exits</mat-error></div>
        </div>
        <div class="d-flex image-preview">
          <ngx-dropzone-preview
            class=""
            *ngFor="let f of attachmentID"
            [removable]="true"
            (removed)="onRemove(f)"
          >
            <ngx-dropzone-label title="{{ f.fileName }}" class="dropzone-label">
              {{ f.fileName }}</ngx-dropzone-label
            >
          </ngx-dropzone-preview>
        </div>
      </div>
    </div>
  </div>`,
  styles: [
    `
      .label {
        font-size: 16px;
        color: rgba(0, 0, 0, 0.54);
        font-family: Roboto, Helvatica, sans-serif !important;
      }
      .icon {
        font-size: 14px;
      }
      .error-message {
        color: #f44336;
        font-size: 11px;
      }

      .image-preview {
        flex-wrap: wrap;
        // width: 118%;
      }

      .dropzone-label {
        overflow-wrap: anywhere;
      }
    `,
  ],
  standalone:true,
  imports:[
    CommonModule,
    MatFormFieldModule,
    FormsModule,
    MatTooltipModule,
    QuillModule,
    MatFormFieldModule,
    MatRadioModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDatetimepickerModule,
    NgxMatSelectSearchModule,
    FormlyMaterialModule,
    MatSelectModule,
    NgxDropzoneModule 
  ]
})
export class MultipleFileUploadWrapper extends FieldWrapper implements OnInit {
  data: any = [];
  attachmentID: any = [];
  files: File[] = [];
  isRequired: any = false;
  fileslength: number = 0;
  maxSizeExceeded!: boolean;
  invalidFileType!: boolean;
  filelengthBool!: boolean;
  submitted: boolean = false;
  fileExits: boolean = true;
  parentArray: any;
  docData: any
  fields: FormlyFieldConfig[] = [];
  constructor(
    private cdr: ChangeDetectorRef,
    private formlyApiService: FormlyApiService,
    private dialog: MatDialog,
    private restService: RestService,
    public loader: LoaderService,
    private translate: TranslateService, private sharedService: SharedService, private zone: NgZone
  ) {
    super();
  }
  getDisable(): any {
    return !!this.field.props?.disabled;
  }
  ngOnInit(): void {
    // this.fields = this.formlyApiService.getdata();
    this.isRequired = this.field?.templateOptions?.required;
    this.fileslength = parseInt(this.field.templateOptions?.fileslength);
    if (this.isRequired) {
      if (this.field?.formControl) {
        this.field.formControl.statusChanges.subscribe((status) => {
          if (this.field.formControl.touched) {
            this.cdr.detectChanges();
          }
        });
        // this.field.formControl.setValue(null);
        this.field.formControl.addValidators(Validators.required);
        this.field.formControl.updateValueAndValidity();
      }
    } else {
      // console.log('The field is not required');
    }
    const formControl = this.field.formControl;
    if (formControl) {
      // Subscribe to value changes
      formControl.valueChanges.subscribe((newValue) => {
        this.field.hooks = {
          onInit: (currentFields: any) => {
            //console.log(currentFields)
          },
        };
      });
    }
    if (this.field.defaultValue) {
      this.attachmentID = this.field.defaultValue.attachmentID

    }
    this.sharedService.currentData.subscribe(data =>
      this.parentArray = data
    )
    setTimeout(() => {
      this.uploadedDocData()
    }, 500)
  }

  onRemove(event: any) {
    const removedAPIIndex = this.attachmentID.indexOf(event);
    if (removedAPIIndex !== -1) {
      this.attachmentID.splice(removedAPIIndex, 1);
      this.updateFieldFormControlValue({
        attachmentID: this.attachmentID,
      });
      this.fileExits = false;
      this.filelengthBool = false;
      this.maxSizeExceeded = false;
      this.invalidFileType = false;
      this.isRequired = false;
      if (this.field.templateOptions?.required && this.attachmentID.length == 0) {
        if (this.field?.formControl) {
          this.isRequired = true;
          this.field.formControl.setAsyncValidators(() =>
            of(Validators.required)
          );
          // Update validity with the new validation rules
          this.field.formControl.updateValueAndValidity();
          this.cdr.detectChanges();
        }
      }
    }
  }

  onFileSelected(event: any) {
    this.submitted = true;
    this.fileExits = false;
    this.filelengthBool = false;
    this.maxSizeExceeded = false;
    this.invalidFileType = false;
    this.isRequired = false;

    event?.addedFiles.forEach((item: any, index: number) => {
      const file: File = event?.addedFiles[index];
      const allowedFileTypes =
        this.field.templateOptions?.['allowedFileTypes'] || [];
      const maxSize =
        (this.field.templateOptions?.['maxSize'] || 5) * 1024 * 1024;
      const fileExists = this.attachmentID.some(
        (existingFile: { fileName: string }) =>
          existingFile.fileName === file.name
      );

      if (this.attachmentID.length === this.fileslength) {
        this.fileExits = false;
        this.filelengthBool = true;
        this.maxSizeExceeded = false;
        this.invalidFileType = false;
        this.isRequired = false;
        this.updateFormControlValidators();
      }

      if (this.attachmentID.length < this.fileslength) {
        if (fileExists) {
          this.fileExits = true;
        } else {
          this.fileExits = false;
        }

        if (!fileExists && file.size > maxSize) {
          this.maxSizeExceeded = true;
          event.addedFiles = [];
          this.setFormControlAsyncValidators(Validators.required);
        } else {
          this.maxSizeExceeded = false;
          this.clearFormControlAsyncValidators();
        }

        if (
          !fileExists &&
          file.size < maxSize &&
          !allowedFileTypes.includes(file.type)
        ) {
          this.setFormControlAsyncValidators(Validators.required);
          this.invalidFileType = true;
          event.addedFiles = [];
        } else {
          this.invalidFileType = false;
          this.clearFormControlAsyncValidators();
        }

        if (
          !fileExists &&
          file.size < maxSize &&
          allowedFileTypes.includes(file.type) &&
          this.attachmentID.length < this.fileslength
        ) {
          this.uploadFileToApi(file);
          this.clearFormControlAsyncValidators();
        }
      }
    });
  }

  private setFormControlAsyncValidators(validator: ValidatorFn): void {
    this.field.formControl?.setAsyncValidators(() => of(validator));
    this.field.formControl?.updateValueAndValidity();
  }

  private clearFormControlAsyncValidators(): void {
    this.field.formControl?.clearAsyncValidators();
    this.field.formControl?.updateValueAndValidity();
  }

  private updateFormControlValidators(): void {
    this.clearFormControlAsyncValidators();
  }

  uploadFilesToApi(files: File[]) {
    for (const file of files) {
      this.uploadFileToApi(file);
    }
  }

  uploadFileToApi(file: File) {
    this.loader.show();
    const formData = new FormData();
    formData.append('fileName', file.name);
    formData.append('title', 'Test Title');
    formData.append('description', 'description');
    formData.append('image', file);
    this.restService
      .postUATData(formData, 'api/digital/core/Document/UploadFile')
      .subscribe({
        next: (data) => {
          if (data.rcode == 200) {
            this.loader.hide();
            if (this.attachmentID.length < this.fileslength) {
              // Handle success or any other actions here
              let multiupload: any = {};
              multiupload.attachmentID = data.rObj.attachmentID
                ? data.rObj.attachmentID
                : null;
              multiupload.fileName = file.name;
              multiupload.blopUploadLocation =
                this.field?.templateOptions?.blopUploadLocation;
              multiupload.uploadedURL = data.rObj.SASURL
              this.attachmentID.push(multiupload);
              this.cdr.detectChanges();
              // Update the form control value with the attachment IDs
              this.updateFieldFormControlValue({
                attachmentID: this.attachmentID,
              });
              // console.log('fields',this.fields)
              // this.fields[0].fieldGroup.forEach((a:any)=>{
              //   if(a.key=="InsuredFirstName"){
              //     a.formControl.setValue("james")
              //     a.templateOptions.customControl.setValue("james")
              //   }
              // })
            }

            // if(!this.field.templateOptions?.isMultiple){
            //   if (this.attachmentID.length ==1) {
            //     this.fileExits=false;
            //   this.filelengthBool=true;
            //   this.maxSizeExceeded=false;
            //   this.invalidFileType=false;
            //   this.isRequired=false;
            //   this.field.formControl?.clearAsyncValidators();
            //   this.field.formControl?.updateValueAndValidity();
            //   }
            // }
            //   if(!this.field.templateOptions?.isMultiple){
            //   if (this.attachmentID.length === this.fileslength) {
            //     // All files have been uploaded successfully
            //     if (this.field && this.field.formControl) {
            //       this.field.formControl.clearAsyncValidators();
            //       this.field.formControl.updateValueAndValidity();
            //     }
            //     this.filelengthBool = false;
            //     this.cdr.detectChanges();
            //   }
            //   else if (this.attachmentID.length !== this.fileslength){
            //     this.filelengthBool = true;
            //     this.isRequired=false;
            //     this.field.formControl?.setAsyncValidators(() => of(Validators.required));
            //     // Update validity with the new validation rules
            //     this.field.formControl?.updateValueAndValidity();

            //   }
            // }
            // if(this.field?.templateOptions?.isRequired){
            //   this.field.formControl?.status=='INVALID'
            // }
            // else{
            //   this.field.formControl?.status=='VALID'
            // }

            // if (!this.field.templateOptions?.isMultiple) {
            //   if (this.attachmentID.length >= 1) {
            //     this.fileExits = false;
            //     this.filelengthBool = true;
            //     this.maxSizeExceeded = false;
            //     this.invalidFileType = false;
            //     this.isRequired = false;
            //     this.field.formControl?.setAsyncValidators(() => of(Validators.required));
            //     this.field.formControl?.updateValueAndValidity();
            //   }
            // }
          } else {
            // Handle error response
            this.loader.hide();
            let a = data.rmsg[0].errorCode ?? 'ERROR';
            let err = this.translate.instant(a);
            const dialogRef = this.dialog.open(MatDialogComponent, {
              panelClass: ['dialog-responsive'],
              disableClose: true,
              data: {
                error: true,
                trnID: data.rObj.transactionRefNum,
                errorMessage: err,
              },
            });
            dialogRef.afterClosed().subscribe();
          }
        },
        error: (error) => {
          // Handle error
          if (
            error.error.rcode != 401 &&
            error.error.rcode != 403 &&
            error.error.rcode != 404 &&
            error.error.rcode != 500
          ) {
            this.loader.hide();
            let a = error.error.rmsg[0].errorCode ?? 'ERROR';
            let err = this.translate.instant(a);
            const dialogRef = this.dialog.open(MatDialogComponent, {
              panelClass: ['dialog-responsive'],
              disableClose: true,
              data: {
                error: true,
                trnID: error.error.trnID,
                errorMessage: err,
              },
            });
            dialogRef.afterClosed().subscribe();
          }
        },
      });
  }
  private updateFieldFormControlValue(partialValue: {
    attachmentID?: number[];
  }) {
    // Merge the current value with the updated part
    if (this.field?.formControl) {
      const newValue = {
        ...this.field.formControl.value,
        ...partialValue,
      };
      this.field.formControl.setValue(newValue);
      this.field.defaultValue = newValue
      this.field.formControl.updateValueAndValidity();
    }
  }
  uploadedDocData() {
    if (!!this.parentArray) {
      this.parentArray[0].filed.forEach((v: any) => {
        const key = v.key;
        if (this.field.key == key && v.defaultValue?.attachmentID) {
          v.defaultValue.attachmentID.forEach((x: any) => {
            const attachmentID = x.attachmentID;
            const fileName = x.fileName;
            this.attachmentID.push({
              attachmentID: attachmentID,
              fileName: fileName,
              uploadedURL: x.uploadedURL
            });
            this.updateFieldFormControlValue({
              attachmentID: this.attachmentID
            });
          });
        }
      });
    }
  }

}
